// extracted by mini-css-extract-plugin
module.exports = {"WrapperAplautReviewsBlock":"AplautReviewsBlock_WrapperAplautReviewsBlock__es1LL","hide":"AplautReviewsBlock_hide__bGHcI"};